import $ from 'jquery';

const WEB_VERSION = 1;
// 실서버 API URL
export const LIVE_URL = 'https://api-event.dabangapp.com';
// 테스트 API URL
export const TEST_URL = 'https://test-dabang-event-api.dabangapp.com';

const defaultError = {
  msg: '서버에러가 발생하였습니다.',
};

class apiCall {
  constructor() {
    /*$.ajaxSetup({
      crossDomain: true,
      dataType: 'json',
      cache: false,
    });*/
  }

  get(path, params = {}) {
    params.call_type = 'web';
    params.version = WEB_VERSION;
    params.api_version = '3.0.1';

    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${path}`,
        method: 'GET',
        contentType: 'application/json;charset=UTF-8',
        data: params,
      }).done((data) => {
        resolve(data);
      }).fail((jqXHR, textStatus, errorThrown) => {
        const err = JSON.parse(jqXHR.responseText ?? defaultError) ?? defaultError;
        reject(err);
      });
    });
  }

  post(path, params = {}) {
    params.call_type = 'web';
    params.version = WEB_VERSION;
    params.api_version = '3.0.1';

    const data = JSON.stringify(params);

    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${path}`,
        method: 'POST',
        contentType: 'application/json;charset=UTF-8',
        data,
      }).done((data, textStatus, jqXHR) => {
        resolve(data);
      }).fail((jqXHR, textStatus, errorThrown) => {
        const err = JSON.parse(jqXHR.responseText ?? defaultError) ?? defaultError;
        reject(err);
      });
    });
  }

  patch(path, params = {}) {
    params.call_type = 'web';
    params.version = WEB_VERSION;
    params.api_version = '3.0.1';

    const data = JSON.stringify(params);

    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${path}`,
        method: 'PATCH',
        contentType: 'application/json;charset=UTF-8',
        data,
      }).done((data, textStatus, jqXHR) => {
        resolve(data);
      }).fail((jqXHR, textStatus, errorThrown) => {
        console.group('responseData');
        console.log(textStatus);
        console.groupEnd()
        const err = JSON.parse(jqXHR.responseText ?? defaultError) ?? defaultError;
        reject(err);
      });
    });
  }
}

export default new apiCall();
